// Shared helpers for rendering order status + money across order views.

import { formatCurrency } from "../common/utils";

// One badge colour per status *name*, shared by shop orders and table orders,
// so the same label (e.g. "Paid", "Pending") always looks the same:
//   pending   yellow   | preparing cyan   | shipped/served primary
//   paid      green    | completed dark   | cancelled      grey
export const STATUS_CLS = {
  pending: "bg-warning text-dark",
  preparing: "bg-info text-dark",
  shipped: "bg-primary",
  served: "bg-primary",
  paid: "bg-success",
  completed: "bg-dark",
  cancelled: "bg-secondary",
};

// Badge class for any order status (shop or table).
export const statusCls = (status) => STATUS_CLS[status] || "bg-dark";

export const STATUS_META = {
  pending: { label: "Pending", cls: STATUS_CLS.pending },
  paid: { label: "Paid", cls: STATUS_CLS.paid },
  shipped: { label: "Shipped", cls: STATUS_CLS.shipped },
  completed: { label: "Completed", cls: STATUS_CLS.completed },
  cancelled: { label: "Cancelled", cls: STATUS_CLS.cancelled },
};

export const ORDER_STATUSES = ["pending", "paid", "shipped", "completed", "cancelled"];

// Returns badge CSS class + fallback label. Prefer translating the label in the
// component via t(`orderStatus.${status}`); `label` is a non-i18n fallback.
export const statusBadge = (status) => {
  const meta = STATUS_META[status] || { label: status, cls: "bg-dark" };
  return meta;
};

// Formats a monetary value as currency. Delegates to the shared formatCurrency
// helper so every price across the app renders consistently.
export const money = (n) => formatCurrency(Number(n || 0));
